import { Search, X } from "lucide-react";

export const TECHS = ["All", "AWS", "GCP", "Azure", "Entra ID", "Azure DevOps", "GitHub", "Ansible", "Terraform", "Kubernetes"];
export const CATS = ["All", "Security", "IAM", "Networking", "Kubernetes", "AI", "DevOps", "Compliance", "FinOps", "Infrastructure"];
export const RANGES = [
  { key: "today", label: "Today" },
  { key: "7d", label: "7 days" },
  { key: "30d", label: "30 days" },
  { key: "90d", label: "90 days" },
  { key: "custom", label: "Custom" },
];
export const STATES = [
  { key: "all", label: "All" },
  { key: "unread", label: "Unread" },
  { key: "read", label: "Read" },
  { key: "high", label: "High priority" },
  { key: "saved", label: "Saved" },
];

function Row({ label, options, value, onChange, testPrefix }) {
  return (
    <div className="flex flex-col md:flex-row md:items-center gap-2 md:gap-4">
      <div className="font-mono text-[10px] uppercase tracking-[0.22em] text-muted-foreground w-24 shrink-0">{label}</div>
      <div className="flex gap-1.5 overflow-x-auto pb-1 -mb-1 [scrollbar-width:none] [&::-webkit-scrollbar]:hidden">
        {options.map((o) => {
          const key = typeof o === "string" ? o : o.key;
          const lab = typeof o === "string" ? o : o.label;
          const active = value === key;
          return (
            <button
              key={key}
              type="button"
              data-testid={`${testPrefix}-${key.toLowerCase().replace(/\s+/g, "-")}`}
              onClick={() => onChange(key)}
              className={`shrink-0 font-mono text-[11px] uppercase tracking-[0.15em] px-3 py-1.5 border transition-colors ${
                active
                  ? "border-accent bg-accent text-accent-foreground"
                  : "border-border text-foreground/75 hover:border-accent hover:text-accent"
              }`}
            >
              {lab}
            </button>
          );
        })}
      </div>
    </div>
  );
}

export default function IntelFilters({ filters, setFilters, showState = true }) {
  const set = (k) => (v) => setFilters((f) => ({ ...f, [k]: v, page: 1 }));
  return (
    <div data-testid="intel-filters" className="border border-border bg-surface/40 backdrop-blur p-5 md:p-6 space-y-4">
      <div className="relative">
        <Search size={14} className="absolute left-0 top-1/2 -translate-y-1/2 text-muted-foreground" />
        <input
          data-testid="intel-search-input"
          value={filters.q}
          onChange={(e) => set("q")(e.target.value)}
          placeholder="Search titles, summaries, tags…"
          className="w-full bg-transparent border-b border-border focus:border-accent focus:outline-none pl-6 pr-8 py-3 font-mono text-sm transition-colors"
        />
        {filters.q && (
          <button
            type="button"
            aria-label="Clear search"
            data-testid="intel-search-clear"
            onClick={() => set("q")("")}
            className="absolute right-0 top-1/2 -translate-y-1/2 text-muted-foreground hover:text-accent"
          >
            <X size={14} />
          </button>
        )}
      </div>
      <Row label="Technology" options={TECHS} value={filters.technology} onChange={set("technology")} testPrefix="filter-tech" />
      <Row label="Category" options={CATS} value={filters.category} onChange={set("category")} testPrefix="filter-cat" />
      <Row label="Time" options={RANGES} value={filters.range} onChange={set("range")} testPrefix="filter-range" />
      {filters.range === "custom" && (
        <div className="flex flex-col md:flex-row md:items-center gap-2 md:gap-4 md:pl-28">
          <input
            type="date"
            data-testid="filter-date-from"
            value={filters.date_from}
            onChange={(e) => set("date_from")(e.target.value)}
            className="bg-transparent border-b border-border focus:border-accent focus:outline-none py-2 font-mono text-sm"
          />
          <span className="font-mono text-xs text-muted-foreground">→</span>
          <input
            type="date"
            data-testid="filter-date-to"
            value={filters.date_to}
            onChange={(e) => set("date_to")(e.target.value)}
            className="bg-transparent border-b border-border focus:border-accent focus:outline-none py-2 font-mono text-sm"
          />
        </div>
      )}
      {showState && <Row label="State" options={STATES} value={filters.state} onChange={set("state")} testPrefix="filter-state" />}
    </div>
  );
}
